// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"mega-menu-module--menuWrapper--2Nls8","menuItem":"mega-menu-module--menuItem--EREYu","button":"mega-menu-module--button--36nVC"};